// // The file contents for the current environment will overwrite these during build.
// // The build system defaults to the dev environment which uses `environment.ts`, but if you do
// // `ng build --env=prod` then `environment.prod.ts` will be used instead.
// // The list of which env maps to which file can be found in `.angular-cli.json`.

// export const environment = {
//   production: false,
//   silent: false,
//   apiUrls: {
//      directory: 'http://directory-axon-api.aquateams.com/api',
//      ams: 'http://ams-api-jshl.m-sas.com/api',
//     // sendIt: 'http://localhost:3010/api',
//     // insight: ' http://localhost:3043/api',

//     // directory: 'http://dev.openage.in/directory/api',
//     // ams: 'http://dev.openage.in/ams/api',
//     sendIt: 'https://api.openage.in/sendIt/api',
//     // drive: 'http://dev.openage.in/drive/api',
//     // gateway: 'http://dev.openage.in/gateway/api',
//     // social: 'http://dev.openage.in/social/api',
//     // discover: 'http://dev.openage.in/discover/api',
//     // bap: 'https://dev.openage.in/bap/api',
//     // insight: 'http://dev.openage.in/insight/api'
//     // idirectory: 'http://directory-api.mindfulsas.com/api',
//     // iams: 'https://api.openage.in/ams/api',
//     drive: 'https://api.openage.in/drive/api',
//     gateway: 'https://api.openage.in/gateway/api',
//     social: 'https://api.openage.in/social/api',
//     discover: 'https://api.openage.in/discover/api',
//     bap: 'https://api.openage.in/bap/api',
//     insight: 'https://api.openage.in/insight/api',
//     reportPortal: 'http://erp-report.aquateams.com',
//   },
//   name: 'dev'
// };

export const environment = {
  production: true,
  apiUrls: {
    directory: 'https:///directory-axon-api.aquateams.com/api',
    ems: 'https:///directory-axon-api.aquateams.com',
    ams: 'https://jshl-api.aquateams.com/api',
    drive: 'http://docs-api.mindfulsas.com',
    website: 'http://www.aquateams.com',
    register: 'http://register.aquateams.com',
    sendIt: 'http://send-it-api.mindfulsas.com',
    bap: 'https://api.openage.in/bap/api',
    insight: 'https://api.openage.in/insight/api',
    reportPortal: 'http://erp-report.aquateams.com',
  },
  organization: {
    code: 'jshll'
  },
  name: 'prod'
};




// WEBPACK FOOTER //
// /opt/build/repo/src/environments/environment.ts